import { AppRoute } from '@agentselly/immodossier-shared';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';
import { contactPageWidgets } from '~/config/widgets/contactPageWidgets';
import { V3ContactPage } from '~/components/contact/V3ContactPage';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_$CONTACTID_CONTACT,
  contactPageWidgets,
  false,
  (widgetProps) => <V3ContactPage {...widgetProps.contactPagePhone} />,
);
